'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _IconBase = require('./IconBase.js');

var _IconBase2 = _interopRequireDefault(_IconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PlotErrorBarsIcon = function PlotErrorBarsIcon(props) {
    return _react2.default.createElement(
        _IconBase2.default,
        _extends({ viewBox: '0 0 32 32' }, props),
        _react2.default.createElement('path', { d: 'M0 9.313h4v3.438H2v4h2v3.25H0v4h12v-4H8v-3.25h1.938v-4H8V9.313h4v-4H0zM32 12V8H20v4h4v3.313h-2v4h2v3.375h-4v4h12v-4h-4v-3.375h2v-4h-2V12z' })
    );
};

exports.default = PlotErrorBarsIcon;


//////////////////
// WEBPACK FOOTER
// ./node_modules/plotly-icons/lib/components/PlotErrorBarsIcon.js
// module id = 659
// module chunks = 0